/* eslint-disable react/display-name */
import React, { useState, useLayoutEffect } from 'react';
import { withTheme } from 'styled-components';
import { compose } from 'recompose';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { useClassroomContext } from 'Context/ClassroomContext';
import { withCapacitor } from 'Util/Capacitors/hoc';
import withConfig from 'Context/ConfigContext/hoc';
import { sendDataToGTM, GTM_EVENT_NAME, GTM_DATA_LAYER_PROPERTY } from 'Util/Analytics';
import useGoToTungKaiLearningPage from 'Util/Hooks/useGoToTungKaiLearningPage';

import { ClassroomFixedView as ClassroomAppShellView, ClassroomFullView } from './ClassroomView';
import { ClassroomLayoutView } from './Components/ClassroomLayout';
import ClearPlusByOnDemandProvider from './Featured/ClearByOnDemand/Contexts/ClearPlusByOnDemandProvider';

const ClassroomView = ({
  history,
  capacitorContext,
  theme: { _breakpoints = {}, colors = {} },
  variant,
  allowContentType,
  partnerLogoUrl,
  courseOwnerLogoUrl,
  appConfig: { uiVariant },
}) => {
  const isAppShellLayout = uiVariant === 'PAAS';
  const mobileWidth = _breakpoints[isAppShellLayout ? 1 : 0];

  const [isMobile, setIsMobile] = useState(window.innerWidth < mobileWidth);
  const { layoutType, courseData } = useClassroomContext();

  const isLearnCraftCourse = courseData?.courseSourceType === 'LEARNCRAFT';

  const location = useLocation();
  const queryParam = queryString.parse(location.search);

  const contentBackgroundColor = isAppShellLayout
    ? colors.contentBackgroundGrey
    : colors.contentDefaultBackgroundColor;

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < mobileWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [mobileWidth]);

  const goToTungKaiLearningPage = useGoToTungKaiLearningPage();

  const handleExitClassroom = async () => {
    if (await goToTungKaiLearningPage()) return;

    if (queryParam.from) {
      const fromURL = decodeURIComponent(queryParam.from);
      window.location = fromURL;
    } else {
      history.push('/');
    }
  };

  const handleGoToDiscussion = (url, courseTitle) => {
    window.open(url, '_blank');

    // logging GTM event
    sendDataToGTM({
      event: GTM_EVENT_NAME.DISCUSSION_BUTTON_CLICK,
      [GTM_DATA_LAYER_PROPERTY.PRODUCT_TITLE]: courseTitle,
    });
  };

  // TODO: Create one drawer panel and set variant to open by different button.
  const { isNative } = capacitorContext || {};

  // SKD and PAAS
  if (variant === ClassroomLayoutView.VARIANTS.FIXED) {
    return (
      <ClassroomAppShellView
        courseOwnerLogoUrl={courseOwnerLogoUrl}
        partnerLogoUrl={partnerLogoUrl}
        allowContentType={allowContentType}
        contentBackgroundColor={contentBackgroundColor}
        handleExitClassroom={handleExitClassroom}
        handleGoToDiscussion={handleGoToDiscussion}
        isMobile={isMobile}
      />
    );
  }

  // ANY
  return (
    <ClearPlusByOnDemandProvider layoutType={layoutType}>
      <ClassroomFullView
        layoutType={layoutType}
        allowContentType={allowContentType}
        handleExitClassroom={handleExitClassroom}
        isMobile={isMobile}
        isNative={isNative}
        isLearnCraftCourse={isLearnCraftCourse}
      />
    </ClearPlusByOnDemandProvider>
  );
};

export default compose(
  withTheme,
  withCapacitor,
  withConfig
)(ClassroomView);
